import { EditUserItem, LicenseCreationEmailRequest, NewUserItem, ShareLicenseDataRequest, UserItem, UserSummary } from 'src/stores/users-store';
import DataStoreMock from './base/data-store';
import FormStoreMock from './base/form-store';
import { CommandResult } from 'src/core/stores/types';
import { Query, QueryResult } from 'src/core/stores/data-store';
import { UserSummaryMockData } from '../data-sources/user-summary';
import { UserItemMockData } from '../data-sources/user-item';
import { ThemeSelection } from 'src/common/themes';
import { GroupType } from '../../stores/groups-store';

export class UserItemStoreMock extends FormStoreMock<UserItem, NewUserItem | EditUserItem> {
  public async load(id: string) {
    this._state.set({
      isBusy: false,
      item: UserItemMockData,
    });
    return UserItemMockData;
  }

  host: string;
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/users`);
    this.host = baseUrl;
  }

  userOrganizationsMembershipBasePath = 'organizations-membership';
  userGroupsBasePath = 'groups';
  sendInvitationPath = 'send-invitation';
  sendResetPasswordEmailPath = 'send-reset-password-email';
  public async getUserItem(id: string, groupTypes: GroupType[]) {
    this._state.set({
      isBusy: false,
      item: UserItemMockData,
    });
    return UserItemMockData;
  }

  public async getUserOrganizationsMembership(id: string): Promise<QueryResult<{ id: string; displayName: string }>> {
    return {} as QueryResult<{ id: string; displayName: string }>;
  }

  public async addUserGroups(id: string, groupIds: string[]) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async deleteUserGroups(id: string, groupIds: string[]) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async sendInvitation(id: string, orgId: string) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async switchMFA(id: string, status: boolean) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async sendResetPasswordEmail(id: string) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async updatePreferredTheme(id: string, theme: ThemeSelection) {}
}

export class UserSummaryStoreMock extends DataStoreMock<UserSummary> {
  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      errorMessage: undefined,
      items: UserSummaryMockData,
      count: UserSummaryMockData.length,
    });
    return true;
  }

  public async getUpdatedUserIds(userIdsOrEmails: string[]) {
    return {};
  }

  public async exportCsv(query: Query, separator: string, fileName: string) {
    return true;
  }

  public async shareLicenseData(item: ShareLicenseDataRequest) {
    return { item: {}, isSuccess: true } as CommandResult<ShareLicenseDataRequest>;
  }

  public async sendLicenseCreationEmail(item: LicenseCreationEmailRequest) {
    return { item: {}, isSuccess: true } as CommandResult<LicenseCreationEmailRequest>;
  }

  organizationsBaseUrl: string;
  emailUrl: string;
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/users`);
    this.organizationsBaseUrl = `${baseUrl}/identity/api/organizations`;
    this.emailUrl = baseUrl;
  }

  public async delete(_id: string, _params?: any) {
    return { item: {}, isSuccess: true } as CommandResult<UserSummary>;
  }

  sendInvitationPath = 'send-invitation';
  public async sendInvitation(_id: string, _orgId: string) {
    return { isSuccess: true, error: '', messages: [] };
  }

  OrganizationMembersBasePath = 'users';
  public async removeFromOrganization(_userId: string, _organizationId: string) {
    return { isSuccess: true, error: '', messages: [] };
  }

  sendResetPasswordEmailPath = 'send-reset-password-email';
  public async sendResetPasswordEmail(id: string) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async resetLockout(id: string) {
    return { isSuccess: true, error: '', messages: [] };
  }
}
